import styled from '@emotion/styled'
import CloseIcon from '@mui/icons-material/Close'
import { Button } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

export const SignOut = styled(Button)`
  ${typography.baseline.regularSans};

  color: ${colors.interactive.tertiaryEnabled};
`

export const GoalActionHeader = styled.span`
  ${typography.baseline.regularSans};
`

export const Close = styled(CloseIcon)`
  cursor: pointer;
  position: absolute;
  right: 16px;
  top: 16px;
`
